import type { OnboardingDetails } from "./onboarding-api.types"

/**
 * Mirrors the first entry in the component mock-data (Aisha Khan / Northwind Retail).
 * decisions is null so the form populates from the Layer 1 snapshot — avoids needing
 * real numeric IDs for LOB / internal company in mock mode.
 */
export const mockOnboardingDetails: OnboardingDetails = {
  id: "00000000-0000-0000-0000-000000000001",
  status: "PendingReview",
  sourceType: "ATS",
  sourceId: "10001",
  placement: {
    workerProfileTypeCode: "WorkerTemp",
    clientDisplayName: "Northwind Retail",
    startDate: "2026-03-01",
    endDate: "2026-08-31",
    primaryBillingRate: 95,
    primaryPaymentRate: 62,
    billingCurrency: "CAD",
    paymentCurrency: "CAD",
    supplier: null,
  },
  worker: {
    firstName: "Aisha",
    lastName: "Khan",
    fullName: "Aisha Khan",
    primaryEmail: "aisha.khan@example.com",
  },
  decisions: null,
  outcome: null,
  createdAt: "2026-01-10T00:00:00Z",
}
